import script from "./AssetDetailAssessmentProgramsLinkDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetDetailAssessmentProgramsLinkDetail.vue?vue&type=script&setup=true&lang=ts"

import "./AssetDetailAssessmentProgramsLinkDetail.vue?vue&type=style&index=0&id=1ec98f8f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ec98f8f"]])

export default __exports__